import { Capacitor } from '@capacitor/core';
import { TokenService } from './tokenService';
import { BrowserStrategy } from './strategies/browserStrategy';
import { CapacitorStrategy } from './strategies/capacitorStrategy';
import type { CookieConfig } from './tokenContracts';

let instance: TokenService | null = null;

export async function createTokenService(topDomain: string): Promise<TokenService> {
  const isNative = Capacitor.isNativePlatform();
  const isProd = import.meta.env.PROD;

  const config: CookieConfig = {
    accessTokenName: 'Bearer',
    refreshTokenName: 'RefreshToken',
    domain: isNative ? '' : topDomain,
    path: '/',
    secure: isProd,
    sameSite: 'Lax'
  };

  if (isNative) {
    const cookieUrl = new URL(import.meta.env.VITE_BASE_API_URL).origin;
    const strategy = new CapacitorStrategy(cookieUrl);
    await strategy.initialize(config);
    instance = new TokenService(config, strategy);
  } else {
    instance = new TokenService(config, new BrowserStrategy());
  }

  return instance;
}

export function getTokenService(): TokenService {
  if (!instance) {
    throw new Error('TokenService not initialized. Call createTokenService() first.');
  }
  return instance;
}
